import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

import Logo from '../../images/logo.svg'
import Privacy from '../../components/privacy/privacypolicy';


const PrivacyPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'Privacy Policy'}  />
            
           <Privacy />
            <Footer />
            <Scrollbar />

        </Fragment>
    )
};
export default PrivacyPage ;
